import { useEffect, useState } from 'react';
import {
  DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton,
  GridToolbarDensitySelector, GridToolbarExportContainer, GridCsvExportMenuItem, esES,
  GridPrintExportMenuItem, gridClasses,
  getGridDateOperators, gridDateComparator
} from '@mui/x-data-grid';
import jwt_decode from "jwt-decode";
import { Alert, Autocomplete, Box, Button, Card, CardContent, CardHeader, Checkbox, Chip, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, FormGroup, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import { AddCircleTwoTone, RemoveCircleTwoTone } from '@mui/icons-material';
import OpenInNewTwoToneIcon from '@mui/icons-material/OpenInNewTwoTone';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useDataContext } from '../../contexts/dataContext';
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import dayjs from "dayjs";
import 'dayjs/locale/es-mx.js'
import ClaveSiiuam from './ClaveSiiuam';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DocumentosAdjuntosSolicitudGuardados from './DocumentosAdjuntosSolicitudGuardados';
import DocumentosAdjuntosFormulario from './DocumentosAdjuntosFormulario';
import mostrarDocumento from '../utils/mostrarDocumento';

dayjs.locale('es-mx')

const fechaSortComparator = (v1, v2) => {
  const date1 = dayjs(v1.fecha);
  const date2 = dayjs(v2.fecha);
  return gridDateComparator(date1, date2)
};

const csvOptions = { utf8WithBom: true };
const printOptions = {
  hideFooter: true,
  hideToolbar: true,
}

const opcionesEstadoFiltrar = [{ value: 'registrada', label: 'Registrada' }, { value: 'autorizada', label: 'Autorizada' }, { value: 'ajustesJefe', label: 'Ajustes Jefe/Director' }, { value: 'ajustesAsistente', label: 'Ajustes Asistente' }, { value: 'firmaAutografa', label: 'En firma autógrafa' }, { value: 'enRevision', label: 'En revisión' }, { value: 'registrarGastos', label: 'Registrar gastos' }, { value: 'devolucionCaja', label: 'Devolución en caja' }, { value: 'concluida', label: 'Concluída' }, { value: 'cancelada', label: 'Cancelada' }, {value: 'atencionCSA', label: 'Atención en la sección de adquisiciones' }]
const opcionesEstado = [{ id: 'registrada', label: 'Registrada' }, { id: 'autorizada', label: 'Autorizada' }, { id: 'ajustesJefe', label: 'Ajustes Jefe/Director' }, { id: 'ajustesAsistente', label: 'Ajustes Asistente' }, { id: 'firmaAutografa', label: 'En firma autógrafa' }, { id: 'enRevision', label: 'En revisión' }, { id: 'registrarGastos', label: 'Registrar gastos' }, { id: 'devolucionCaja', label: 'Devolución en caja' }, { id: 'concluida', label: 'Concluída' }, { id: 'cancelada', label: 'Cancelada' }]
const opcionesEstadoAsistente = [{ id: 'enRevision', label: 'En revisión' }, { id: 'firmaAutografa', label: 'En firma autógrafa' }, { id: 'ajustesAsistente', label: 'Ajustes' }, { id: 'registrarGastos', label: 'Registrar gastos' }, { id: 'devolucionCaja', label: 'Devolución en caja' }, { id: 'concluida', label: 'Concluída' }, { id: 'cancelada', label: 'Cancelada' }]
const opcionesEstadoContrato = [{ id: 'ajustesAsistente', label: 'Ajustes' }, { id: 'concluida', label: 'Concluída' }, { id: 'cancelada', label: 'Cancelada' }]
const opcionesEstadoJefatura = [{ id: 'autorizada', label: 'Autorizada' }, { id: 'ajustesJefe', label: 'Ajustes' }, { id: 'cancelada', label: 'Cancelada' }]
const opcionesEstadoPago = [{ id: 'registrado', label: 'Registrado' }, { id: 'enProceso', label: 'En proceso' }, { id: 'enAjustes', label: 'En ajustes' }, { id: 'tramiteConcluido', label: 'Trámite concluido' }]
const estadoMap = opcionesEstadoFiltrar.reduce((acc, { value, label }) => {
  acc[value] = label;
  return acc;
}, {});
/*const opcionesTipo = ['adquisiciones', 'asistenciaEventos', 'compraLibros', 'comprobante', 'conferenciante', 'gastosViaje', 'gastosViajePartida', 'facturas', 'contrato', 'serviciosProfesionales', 'reembolso', 'reembolsoCajaChica', 'transferencia',
  'valeCaja', 'valeDefinitivo', 'viaticos']*/
const opcionesTipo = [{ value: 'adquisiciones', label: 'Adquisiciones' }, { value: 'asistenciaEventos', label: 'Asistencia a eventos' },{ value: 'aePartida', label: 'Asistencia a eventos (más de una partida)' }, { value: 'compraLibros', label: 'Compra de libros y revistas' },
{ value: 'comprobante', label: 'Comprobante' }, { value: 'conferenciante', label: 'Conferenciante invitado' }, { value: 'conferenciantePartida', label: 'Conferenciante invitado (más de una partida)' }, { value: 'gastosViaje', label: 'Gastos de viaje' }, { value: 'gastosViajePartida', label: 'Gastos de viaje (más de una partida)' }, { value: 'facturas', label: 'Pago de factura' },
{ value: 'contrato', label: 'Pago por contrato' }, { value: 'serviciosProfesionales', label: 'Pago único de servicios profesionales' }, { value: 'reembolso', label: 'Reembolso' },
{ value: 'reembolsoCajaChica', label: 'Reembolso caja chica' }, { value: 'transferencia', label: 'Transferencia (una sola partida)' }, { value: 'transferencias', label: 'Transferencia' },
{ value: 'valeCaja', label: 'Vale de caja' }, { value: 'valeDefinitivo', label: 'Vale definitivo' }, { value: 'viaticos', label: 'Viáticos' }, { value: 'viaticosPartida', label: 'Viáticos (más de una partida)' }]

const CustomExportButton = (props) => (
  <GridToolbarExportContainer {...props}>
    <GridCsvExportMenuItem options={csvOptions} />
    <GridPrintExportMenuItem options={printOptions} />
  </GridToolbarExportContainer>
);

const colocarNombre = (ruta) => {
  if (!ruta || ruta === '')
    return ''
  const indice = Number(ruta.indexOf("factura")) + 9
  return ruta.slice(indice)

}
const verificarDisponible = () => {
  const idEntidad = sessionStorage.getItem('idEntidad')
  const idEntidadSuperior = sessionStorage.getItem('idEntidadSuperior')
  if (Number(idEntidad) === Number(1) || Number(idEntidad) === Number(2) || Number(idEntidadSuperior) === Number(1) || Number(idEntidadSuperior) === Number(2)) {
    return false
  }
  return true
}

const colocarNombreOficio = (ruta) => {
  if (!ruta || ruta === '')
    return ''
  const indice = Number(ruta.indexOf("oficio_"))
  return ruta.slice(indice)
}

const colocarNombreDocumento = (ruta) => {
  const indice = Number(ruta.indexOf("documentosSolicitud")) + 20
  return ruta.slice(indice)

}

const columns = [
  { id: 'ruta', label: 'Documento', width: 150, align: 'center' },
  { id: 'descripcion', label: 'Descripción', width: 150, align: 'justify' },
];

const CustomToolbar = (props) => (
  <GridToolbarContainer {...props}>
    <GridToolbarColumnsButton />
    <GridToolbarFilterButton />
    <GridToolbarDensitySelector />
    <CustomExportButton />
  </GridToolbarContainer>
);

export default function SolicitudesFacturasListado() {
  const d = new Date();
  let year = d.getFullYear();
  const { esJefe, esAsistente } = useDataContext()
  const [isAsistente, setIsAsistente] = useState(false)
  const params = useParams()
  const idPlaneacion = params.idPlaneacion;
  const [data, setData] = useState({ columns: [], rows: [] })
  const [pageSize, setPageSize] = useState(15)
  const [openDialog, setOpenDialog] = useState(false)
  const [openContrato, setOpenContrato] = useState(false)
  const [value, setValue] = useState({ id: null, label: null })
  const [solicitud, setSolicitud] = useState(null)
  const [open, setOpen] = useState(false);
  const [openDocumentos, setOpenDocumentos] = useState(false)
  const [mensaje, setMensaje] = useState('');
  const [openPago, setOpenPago] = useState(false);
  const [mensajePago, setMensajePago] = useState('');
  const [asistentes, setAsistentes] = useState([])
  const [errorPedido, setErrorPedido] = useState(false);
  const [severity, setSeverity] = useState('error')
  const [severityPago, setSeverityPago] = useState('error')
  const [contrato, setContrato] = useState(null)
  const [loading, setLoading] = useState(false);
  const [ocultarContratos, setOcultarContratos] = useState(true)
  const [actualizaFiltro, setActualizaFiltro] = useState(0)
  const [claves, setClaves] = useState([])
  const [clave, setClave] = useState('')
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [documentosGuardados, setDocumentosGuardados] = useState([])
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    fecha: false,
  });
  const [expanded, setExpanded] = useState({});

  // Función para cambiar el estado de expansión de un acordeón específico
  const handleChange = (id) => (event, isExpanded) => {
    setExpanded((prevState) => ({
      ...prevState,
      [id]: isExpanded, // Solo actualizamos el acordeón con el id correspondiente
    }));
  };


  const handleAccordionChange = (pago) => {
    pago.expanded = !pago.expanded
    setContrato({ ...contrato });
  };

  const handleDelete = async (clave, solicitud) => {

    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/borrarClave/${clave.id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    })

    if (res.status === 200) {
      setSolicitud({ ...solicitud, claveSiiuams: solicitud.claveSiiuams.filter(claveS => claveS.id !== clave.id) })
    }
    return

  }

  // Operador de filtro personalizado
  const dateRangeOperator = {
    label: 'entre',
    value: 'dateRange',
    getApplyFilterFn: (filterItem) => {

      if (!filterItem.value || !filterItem.value[0] || !filterItem.value[1]) {
        return null;
      }
      return ({ value }) => {
        /*console.log(`value ${value}`)
        console.log(`startDate ${filterItem.value[0]}`)
        console.log(`endDate ${filterItem.value[1]}`)*/
        const cellDate = value;
        const startDate = filterItem.value[0]
        const endDate = filterItem.value[1]

        /*console.log(`cellDate ${dayjs(cellDate).format('YYYY/MM/DD')}`)
        console.log(`startDate ${ dayjs(startDate).format('YYYY/MM/DD')}`)
        console.log(`endDate ${dayjs(endDate).format('YYYY/MM/DD')}`)
        console.log(`return ${dayjs(cellDate).format('YYYY/MM/DD') >= dayjs(startDate).format('YYYY/MM/DD') && cellDate <= dayjs(endDate).format('YYYY/MM/DD')}`)*/
        return dayjs(cellDate).format('YYYY/MM/DD') >= dayjs(startDate).format('YYYY/MM/DD') && dayjs(cellDate).format('YYYY/MM/DD') <= dayjs(endDate).format('YYYY/MM/DD');
      };
    },
    InputComponent: ({ item, applyValue }) => (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box display="flex" gap={1}>
          <TextField
            label="Fecha inicio"
            type="date"
            value={startDate}
            //onChange={handleDateChange}
            onChange={(event) => {
              const date = event.target.value
              setStartDate(date);
              //console.log(JSON.stringify(item))
              applyValue({ ...item, value: [date, item.value ? item.value[1] : null] });

            }}
            InputLabelProps={{
              shrink: true, // Para que la etiqueta no cubra la fecha seleccionada
            }}
            variant="standard"
          />
          <TextField
            label="Fecha fin"
            type="date"
            value={endDate}
            onChange={(event) => {
              const date = event.target.value
              setEndDate(date);
              //applyValue({ ...item, value: date });
              applyValue({ ...item, value: [item.value ? item.value[0] : null, date] });

            }}
            InputLabelProps={{
              shrink: true, // Para que la etiqueta no cubra la fecha seleccionada
            }}
            variant="standard"
          />
        </Box>
      </LocalizationProvider>
    ),
  };

  const fetchToken = async (id) => {
    try {
      const response = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/generarTokenTemporal`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "id": id
        }
      });

      const data = await response.json();
      console.log(`data.token ${data.token}`)
      return data.token;
    } catch (error) {
      console.error('Error al obtener token:', error);
      return null;
    }
  };

  const token = sessionStorage.getItem('token')
  const decoded = jwt_decode(token);
  const obtenerReglas = () => {
    let reglas
    const perfilElegido = sessionStorage.getItem('perfilElegido')
    switch (perfilElegido) {
      case 'asistente':
        reglas = decoded.rulesAsistente
        break
      case 'investigador':
        reglas = decoded.rulesJefaturaArea
        break
      case 'coordinacion':
        reglas = decoded.rulesCoordinacion
        break
      case 'jefe':
        reglas = decoded.rulesJefatura
        break
      case 'administracion':
        reglas = decoded.rulesAdministracionProyecto
        break
      default:
        break
    }
    return reglas
  }

  let reglas = decoded.rules

  if (!reglas)
    reglas = obtenerReglas()

  const cargarDatosTabla = async () => {
    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/${idPlaneacion}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    }
    )
    const plan = await res.json()
    let isAsistente = false
    if (reglas) {
      for (let i = 0; i < reglas.length; i++) {
        if (reglas[i].action === 'asistente') {
          isAsistente = true
          setIsAsistente(true)
        }
      }
    }

    /*let url

    if(Boolean(isAsistente))
      url=`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/porPlanAsistente/${idPlaneacion}`;
    else*/
    const url = `http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/porPlan/${idPlaneacion}`;
    const resSolicitudes = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    })

    let solicitudes = await resSolicitudes.json()
    //console.log(`PLAN ${JSON.stringify(plan)}`)
    await Promise.all(
      solicitudes = solicitudes.map((row) => {
        if (row.tipo === 'facturas') {
          const rutaPDF = colocarNombre(row.facturas[0].rutaPDF);
          console.log(`rutaPDF ${rutaPDF}`)

          fetchToken(row.facturas[0].id).then(token => {
            if (token) {
              const url = `http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/mostrarDocumentoReporte?token=${token}`;
              // Aquí puedes actualizar el valor de la fila con el enlace
              row.rutaPDFLink = `=HIPERVINCULO("${url}", "${rutaPDF}")`;
              console.log(`row.rutaPDFLink ${JSON.stringify(row.rutaPDFLink)}`)
            }
          });

        }
        return row;
      })
    )

    if (Boolean(isAsistente) && Boolean(ocultarContratos)) {
      const solicitudesFiltradas = solicitudes.filter(solicitud => {
        if (solicitud.tipo !== 'contrato')
          return solicitud
        else {
          return solicitud.contratos.some(contrato =>
            contrato.pagoContratos.some(pago =>
              pago.estado && !['tramiteConcluido'].includes(pago.estado) // Filtra estados 'null' y 'tramiteConcluido'
            )
          );
        }
      });
      solicitudes = solicitudesFiltradas
    }

    const resUsuarios = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/academicos/${plan.idEntidad}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    })

    const responsables = await resUsuarios.json()
    //console.log(`responsables ${JSON.stringify(responsables)}`)
    const buscadorResponsables = []
    if (resUsuarios.status !== 500) {
      responsables.map(async (responsable) => {
        buscadorResponsables.push(`${responsable.nombre} ${responsable.apellidoPaterno} ${responsable.apellidoMaterno}`)

      })
    }

    setClaves([]);

   

    const columnas = [{
      field: "folio", width: 180, headerName: "Folio", hide: false, sortable: true, filterable: true, renderCell: ({ value, row }) => (
        <span style={{ wordBreak: 'break-word', width: '100%' }}>
          {value}
          {row.claveSiiuams.length > 0 ? <>
            <Divider></Divider>
            <div><strong>Claves SIIUAM</strong></div></> : <></>}
          {row.claveSiiuams ? row.claveSiiuams.map((clave) => {
            return (
              <div style={{ wordBreak: 'break-all' }}>
                {clave.clave} {isAsistente ? <Tooltip title="Eliminar"><IconButton variant='text' style={{ color: 'darkred', fontSize: '1em' }} disabled={loading} onClick={async () => await handleDelete(clave, row)}><i className="bi bi-trash3"></i></IconButton></Tooltip> : <></>}
              </div>
            );
          }) : <></>}
          {isAsistente ? <ClaveSiiuam folio={value} solicitud={row} setSolicitud={setSolicitud}></ClaveSiiuam> : <></>}
        </span>)
    },
    {
      field: "tipo", width: 100, headerName: "Tipo", hide: false, sortable: true, filterable: true, type: "singleSelect", valueOptions: opcionesTipo,
      valueFormatter: (params) => {
        const option = opcionesTipo.find(opt => opt.value === params.value);
        return option ? option.label : params.value;
      },
      renderCell: ({ value, row }) => {
        const option = opcionesTipo.find(opt => opt.value === value);
        const tipoSolicitud = row.viaticos[0] ? row.viaticos[0] :
          row.asistenciaEventos[0] ? row.asistenciaEventos[0] :
            row.gastosViajes[0] ? row.gastosViajes[0] :
              row.conferenciantes[0] ? row.conferenciantes[0] :
                row.valeCajas[0] ? row.valeCajas[0] : null
        return `${option ? option.label : params.value} ${tipoSolicitud ? tipoSolicitud.tipoServicio === 'aComprobar' ? ' a comprobar' : ' con comprobante' : ''}`;
      }
    },
    { field: "solicitante", width: 150, headerName: "Solicitante", hide: false, sortable: true, filterable: true, type: "singleSelect", "valueOptions": buscadorResponsables },
    {
      field: "monto", width: 150, headerName: "Monto", headerAlign: 'left', hide: false, sortable: false, filterable: true, type: "number", valueFormatter: ({ value }) => (value ? value.toLocaleString("es-MX", { style: "currency", currency: "MXN" }) : 'Sin definir'),
      renderCell: ({ value }) => (value ? value.toLocaleString("es-MX", { style: "currency", currency: "MXN" }) : 'Sin definir')
    },
    {
      field: "documentoSolicituds", width: 200, headerName: "Documentos", disableExport: false, filterable: false, hide: false,
      renderCell: (params) => {
        const { row, value } = params.value || {};
        return (
          <span style={{ wordBreak: 'break-word', width: '100%' }}>
            {value.map((documento) => {
              return (
                documento.tipo === 'oficioSolicitud' ? (
                  <Button key={documento.id}
                    size='small'
                    variant='contained'
                    style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '80%' }}
                    onClick={async () => { await desplegarDocumentoPDF(documento) }}
                  >
                    <span style={{ wordBreak: 'break-all' }}>
                      {colocarNombreOficio(documento.ruta)} <PictureAsPdfTwoToneIcon />
                    </span>
                  </Button>
                ) : null
              );
            })}
            {
              <>
                {row.tipo === 'viaticos' ? <><br />{row.viaticos[0].rutaCarta ? <Button size='small' variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '80%' }} onClick={async () => { await desplegarDocumentoPDF(row.viaticos[0]) }}>Carta</Button> : <></>} <br /><br /><br />
                  <h4>Facturas/Comprobantes</h4>{row.viaticos[0].facturaComprobantes.map((factura) => { return (<div key={factura.id}><br />{factura.rutaPDF ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(factura.rutaPDF)}`} download={colocarNombre(factura.rutaPDF)}>{colocarNombre(factura.rutaPDF)}</Button> : <></>}<br />{factura.rutaXML ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(factura.rutaXML)}`} download={colocarNombre(factura.rutaXML)}>{colocarNombre(factura.rutaXML)}</Button> : <></>}</div>) })}</>
                  : row.tipo === 'asistenciaEventos' ? <><br />{row.asistenciaEventos[0].rutaCarta ? <Button size='small' variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '80%' }} onClick={async () => { await desplegarDocumentoPDF(row.asistenciaEventos[0]) }}>Carta</Button> : <></>} <br /><br /><br />
                    <h4>Facturas/Comprobantes</h4>{row.asistenciaEventos[0].facturaAEs.map((factura) => { return (<div key={factura.id}><br />{factura.rutaPDF ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(factura.rutaPDF)}`} download={colocarNombre(factura.rutaPDF)}>{colocarNombre(factura.rutaPDF)}</Button> : <></>}<br />{factura.rutaXML ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(factura.rutaXML)}`} download={colocarNombre(factura.rutaXML)}>{colocarNombre(factura.rutaXML)}</Button> : <></>}</div>) })}</>
                    : row.tipo === 'gastosViaje' ? <><br />{row.gastosViajes[0].rutaCarta ? <Button size='small' variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '80%' }} onClick={async () => { await desplegarDocumentoPDF(row.gastosViajes[0]) }}>Carta</Button> : <></>} <br /><br /><br />
                      <h4>Facturas/Comprobantes</h4>{row.gastosViajes[0].facturaGastosViajes.map((factura) => { return (<div key={factura.id}><br />{factura.rutaPDF ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(factura.rutaPDF)}`} download={colocarNombre(factura.rutaPDF)}>{colocarNombre(factura.rutaPDF)}</Button> : <></>}<br />{factura.rutaXML ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(factura.rutaXML)}`} download={colocarNombre(factura.rutaXML)}>{colocarNombre(factura.rutaXML)}</Button> : <></>}</div>) })}</>
                      : row.tipo === 'gastosViajePartida' ? <><br />{row.gastosViajes[0].rutaCarta ? <Button size='small' variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '80%' }} onClick={async () => { await desplegarDocumentoPDF(row.gastosViajes[0]) }}>Carta</Button> : <></>} <br /><br /><br />
                        <h4>Facturas/Comprobantes</h4>{row.gastosViajes[0].gVPs.map((partida) => { return partida.facturaGastosViajes.map((factura) => { return (<div key={factura.id}><br />{factura.rutaPDF ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(factura.rutaPDF)}`} download={colocarNombre(factura.rutaPDF)}>{colocarNombre(factura.rutaPDF)}</Button> : <></>}<br />{factura.rutaXML ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(factura.rutaXML)}`} download={colocarNombre(factura.rutaXML)}>{colocarNombre(factura.rutaXML)}</Button> : <></>}</div>) }) })}</>
                        : row.tipo === 'conferenciante' ? <><br />{row.conferenciantes[0].rutaCarta ? <Button size='small' variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '80%' }} onClick={async () => { await desplegarDocumentoPDF(row.conferenciantes[0]) }}>Carta</Button> : <></>} <br /><br /><br />
                          <h4>Facturas/Comprobantes</h4>{row.conferenciantes[0].facturaCIs.map((factura) => { return (<div key={factura.id}><br />{factura.rutaPDF ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(factura.rutaPDF)}`} download={colocarNombre(factura.rutaPDF)}>{colocarNombre(factura.rutaPDF)}</Button> : <></>}<br />{factura.rutaXML ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(factura.rutaXML)}`} download={colocarNombre(factura.rutaXML)}>{colocarNombre(factura.rutaXML)}</Button> : <></>}</div>) })}</>
                          : row.tipo === 'valeCaja' ? <><br />{row.valeCajas[0].rutaCarta ? <Button size='small' variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '80%' }} onClick={async () => { await desplegarDocumentoPDF(row.valeCajas[0]) }}>Carta</Button> : <></>} <br /><br /><br />
                            <h4>Facturas/Comprobantes</h4>{row.valeCajas[0].facturaValeCajas.map((factura) => { return (<div key={factura.id}><br />{factura.rutaPDF ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(factura.rutaPDF)}`} download={colocarNombre(factura.rutaPDF)}>{colocarNombre(factura.rutaPDF)}</Button> : <></>}<br />{factura.rutaXML ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(factura.rutaXML)}`} download={colocarNombre(factura.rutaXML)}>{colocarNombre(factura.rutaXML)}</Button> : <></>}</div>) })}</>
                            : row.tipo === 'facturas' ? <><br /><Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(row.facturas[0].rutaPDF)}`} download={colocarNombre(row.facturas[0].rutaPDF)}>{colocarNombre(row.facturas[0].rutaPDF)}</Button><br /><Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(row.facturas[0].rutaXML)}`} download={colocarNombre(row.facturas[0].rutaXML)}>{colocarNombre(row.facturas[0].rutaXML)}</Button></>
                              : row.tipo === 'adquisiciones' ? <><br /><Button color='success' size='small' onClick={async () => { await desplegarDocumentoPDF(row.adquisicions[0], 'cotizacion') }}>cotizacion.pdf</Button>{row.adquisicions[0].rutaPDF ? <><br /><Button color='success' size='small' onClick={async () => { await desplegarDocumentoPDF(row.adquisicions[0]) }}>factura.pdf</Button></> : row.adquisicions[0].adquisicionCSA?.rutaFactura ? <><br /><Button color='success' size='small' onClick={async () => { await mostrarDocumento(row.adquisicions[0].adquisicionCSA?.rutaFactura, 'pdf') }}>factura.pdf</Button></> : <></>}{row.adquisicions[0].pedido ? <><br /><Button color='success' size='small' onClick={async () => { await desplegarDocumentoPDF(row.adquisicions[0], 'pedido') }}>pedido.pdf</Button></> : row.adquisicions[0].adquisicionCSA?.rutaPedido ? <><br /><Button color='success' size='small' onClick={async () => { await mostrarDocumento(row.adquisicions[0].adquisicionCSA?.rutaPedido, 'pdf') }}>pedido.pdf</Button></> : <></>}</>
                                : row.tipo === 'compraLibros' ? <><br /><Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(row.compraLRs[0].rutaPDF)}`} download={colocarNombre(row.compraLRs[0].rutaPDF)}>{colocarNombre(row.compraLRs[0].rutaPDF)}</Button><br /><Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(row.compraLRs[0].rutaXML)}`} download={colocarNombre(row.compraLRs[0].rutaXML)}>{colocarNombre(row.compraLRs[0].rutaXML)}</Button></>
                                  : row.tipo === 'serviciosProfesionales' ? <><br /><Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(row.serviciosProfesionales[0].rutaPDF)}`} download={colocarNombre(row.serviciosProfesionales[0].rutaPDF)}>{colocarNombre(row.serviciosProfesionales[0].rutaPDF)}</Button><br /><Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(row.serviciosProfesionales[0].rutaXML)}`} download={colocarNombre(row.serviciosProfesionales[0].rutaXML)}>{colocarNombre(row.serviciosProfesionales[0].rutaXML)}</Button>{/* LOS DOCUMENTOS ADJUNTOS YA NO SE MOSTRARÁN EN EL LISTADO SINO EN LA VENTANA CORRESPONDIENTE row.documentoAdjuntoSolicituds.map((documento) => { return (<div key={documento.id}><br />{<Tooltip title={documento.descripcion} arrow style={{ textAlign: 'left' }}><Button color='success' size='small' onClick={async () => { await desplegarDocumentoPDF(documento) }}>{colocarNombreDocumento(documento.ruta)}</Button></Tooltip>}</div>) })*/}</>
                                    : row.tipo === 'reembolso' ? <><br /><Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(row.reembolsos[0].rutaPDF)}`} download={colocarNombre(row.reembolsos[0].rutaPDF)}>{colocarNombre(row.reembolsos[0].rutaPDF)}</Button><br />{row.reembolsos[0].rutaXML ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(row.reembolsos[0].rutaXML)}`} download={colocarNombre(row.reembolsos[0].rutaXML)}>{colocarNombre(row.reembolsos[0].rutaXML)}</Button> : <></>}</>
                                      : row.tipo === 'reembolsoCajaChica' ? <>
                                        <h4>Facturas/Comprobantes</h4>{row.reembolsoPartidas.map((partida) => { return partida.facturaReembolsos.map((factura) => { return (<div key={factura.id}><br />{factura.rutaPDF ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(factura.rutaPDF)}`} download={colocarNombre(factura.rutaPDF)}>{colocarNombre(factura.rutaPDF)}</Button> : <></>}<br />{factura.rutaXML ? <Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoXML/${colocarNombre(factura.rutaXML)}`} download={colocarNombre(factura.rutaXML)}>{colocarNombre(factura.rutaXML)}</Button> : <></>}</div>) }) })}</>
                                        : row.tipo === 'valeDefinitivo' ? <><br /><Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoSolicitudPDFValeDefinitivo/${row.valeDefinitivo.id}/oficio`}>{colocarNombreDocumento(row.valeDefinitivo.rutaOficio)}</Button><br /><Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoSolicitudPDFValeDefinitivo/${row.valeDefinitivo.id}/reporte`}>{colocarNombreDocumento(row.valeDefinitivo.rutaReporte)}</Button></>
                                          : row.tipo === 'comprobante' ? <><br /><Button color='success' size='small' href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoSolicitudPDF/${colocarNombreDocumento(row.comprobantes[0].ruta)}`} download={colocarNombreDocumento(row.comprobantes[0].ruta)}>{colocarNombreDocumento(row.comprobantes[0].ruta)}</Button></>
                                            : row.tipo === 'contrato' ? <><br /><Button variant='contained' color='primary' style={{ margin: 4 }} size='small' onClick={() => { setSolicitud(row); setContrato(row.contratos[0]); setOpenContrato(true) }}>Información de pagos<OpenInNewTwoToneIcon></OpenInNewTwoToneIcon></Button></>
                                              : <></>}
              </>}
            <Button variant='contained' style={{ marginTop: 20 }} color='secondary' type='button' size='small' onClick={() => handleOpenDocumentos(row)}>
              Añadir otros documentos <OpenInNewTwoToneIcon></OpenInNewTwoToneIcon>
            </Button>
          </span >)
      },
      valueGetter: (params) => ({
        value: params.value,  // El valor de la celda
        row: params.row,      // Toda la fila
      }),

      valueFormatter: (params) => {
        const { row } = params.value || {};

        if (row.tipo === "facturas") {
          return row.rutaPDFLink
          /*return fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/generarTokenTemporal`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "ruta": rutaPDF // Envía la ruta en los headers
            }
          }
          )
            .then(res => res.json())
            .then(data => {
              const token = data.token;
              const url = `http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/mostrarDocumentoReporte?token=${token}`;

              return `=HIPERVINCULO(\"${url}\", \"${rutaPDF}\")`;
            })
            .catch(() => "");*/
        }

        return "";
      }

    },
    {
      field: 'fecha',
      headerName: 'Fecha',
      width: 150,
      type: 'date',
      valueGetter: (params) => params.row.createdAt, // Esta es solo para filtrado
      filterable: true,
      disableExport: true,
      hide: true,
      filterOperators: [dateRangeOperator].concat(getGridDateOperators()),
    },
    {
      field: "createdAt", width: 150, headerName: "Fecha", hide: false, sortable: true, filterable: false,
      valueGetter: (params) => {
        const { row } = params;
        const fecha = row.createdAt;
        let fechasPago = ''
        if (row.tipo === 'contrato')
          fechasPago = row.contratos[0].pagoContratos.map((pago) => pago.fecha ? `Pago: ${dayjs(pago.fecha).format('DD/MMM/YYYY')}\n` : '')
        if (row.tipo === 'serviciosProfesionales')
          fechasPago = row.serviciosProfesionales[0].fecha ? `Pago: ${dayjs(row.serviciosProfesionales[0].fecha).format('DD/MMM/YYYY')}\n` : ''
        return { fecha, fechasPago };
      },
      valueFormatter: ({ value }) => `${(new Date(value.fecha).toLocaleDateString('es-MX', { day: "2-digit", month: "short", year: "numeric" }))} ${value.fechasPago}`, renderCell: ({ value, row }) => (
        (<span>{(new Date(value.fecha)).toLocaleDateString('es-MX', { day: "2-digit", month: "short", year: "numeric" })}<br />{row.tipo === 'contrato' ? row.contratos[0].pagoContratos.map((pago) => pago.fecha ? `Pago: ${dayjs(pago.fecha).format('DD/MMM/YYYY')}\n` : '') : ''}
          {row.tipo === 'serviciosProfesionales' ? row.serviciosProfesionales[0].fecha ? `Pago: ${dayjs(row.serviciosProfesionales[0].fecha).format('DD/MMM/YYYY')}\n` : '' : ''}<br /></span>)

      ),
      sortComparator: fechaSortComparator
    },
    {
      field: "estado", width: 150, headerName: "Estado", hide: false, sortable: true, filterable: true, type: "singleSelect", "valueOptions": opcionesEstadoFiltrar, valueFormatter: ({ value }) => estadoMap[value] || '', renderCell: ({ value, row }) => (<span style={{ whiteSpace: 'break-spaces' }}>{opcionesEstado.filter(opcionesEstado => opcionesEstado.id === value)[0] ? opcionesEstado.filter(opcionesEstado => opcionesEstado.id === value)[0].label : null}&nbsp;
        {row.tipo === 'contrato' ? <Typography component='div' style={{ color: 'rgb(156, 39, 176)', fontSize: '0.75rem' }}>{`Aquí se cambia el estado de la solicitud en general, para cambiar el estado de los pagos presionar el botón 'Información de pagos'`}</Typography> : ''}
        {Number(plan.anio) < Number(year) ? <></> : <Button variant='contained' onClick={() => { handleClickOpen(row) }} style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white' }}>Cambiar estado</Button>}</span>)
    },
    {
      field: "comentarioSolicituds", width: 170, headerName: "Comentarios", hide: false, sortable: false, disableExport: true, filterable: false,
      renderCell: ({ value, row }) =>
      (<Grid container justifyContent='stretch' spacing={2} style={{ marginTop: 2 }}>
        <Grid item xs={12}>
          {value.length > 1 ?
            !row.ocultar ? <RemoveCircleTwoTone sx={{ color: 'green', cursor: 'pointer' }} titleAccess='Ver sólo el último comentario' onClick={() => { row.ocultar = true; console.log('mostrar todos false, ocultar true') }} />
              : <AddCircleTwoTone sx={{ color: 'green', cursor: 'pointer' }} titleAccess='Ver todos los comentarios' onClick={() => { row.ocultar = false; console.log('mostrar todos true ocultar este false') }} />
            : <></>}
        </Grid>
        {value.length > 0 ? (!row.ocultar ? value.map((comentario) => {
          return (<Grid item xs={12} key={comentario.id}><div style={{ wordBreak: 'break-word', width: '150px', display: 'block', whiteSpace: 'pre-line' }}><strong>{comentario.responsableComentario} <span style={{ fontSize: '0.5rem' }}>({estadoMap[comentario.estado] || comentario.estado} {new Date(comentario.createdAt).toLocaleString('es-MX', { day: "2-digit", month: "short", year: "numeric" })})</span></strong><br />{comentario.comentarios}
          </div></Grid>)
        }) : value[0] && row.ocultar ? <Grid item xs={12} key={comentario.id}><div style={{ wordBreak: 'break-word', width: '150px', display: 'block', whiteSpace: 'pre-line' }}><strong>{value[0].responsableComentario} <span style={{ fontSize: '0.5rem' }}>({estadoMap[value[0].estado] || value[0].estado} {new Date(value[0].createdAt).toLocaleString('es-MX', { day: "2-digit", month: "short", year: "numeric" })})</span></strong><br />{value[0].comentarios}
        </div></Grid> : <></>) : <></>}</Grid>)
    }
    ]

    if (verificarDisponible()) {
      columnas.push({
        field: "idProyecto", width: 150, align: 'center', sortable: false, disableExport: true, filterable: false,
        headerName: 'Proyecto',
        renderCell: ({ value, row }) => (
          value ? <Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white' }} key={value}><Link to={`/proyectoInforme/${value}`} style={{ textDecoration: 'none', color: 'white' }}>Proyecto</Link></Button> : <div style={{ whiteSpace: 'break-spaces', alignContent: 'center' }}>{/*<Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white' }}><Link to={`/proyectoInforme/${row.transferenciaDestinos[0].proyecto.id}`} style={{ textDecoration: 'none', color: 'white' }}>{row.transferenciaDestinos[0].proyecto.clave}</Link></Button>*/}{
            row.tipo === 'transferencia' || row.tipo === 'transferencias' ? row.proyectos.map((proyecto) => {
              return (<Button variant='contained' key={proyecto.id} style={{ margin: 20, backgroundColor: "darkgreen", color: 'white' }}><Link to={`/proyectoInforme/${proyecto.id}`} style={{ textDecoration: 'none', color: 'white' }}>{proyecto.clave}</Link></Button>)
            }) :
              row.tipo === 'contrato' ? row.contratos[0].pagoContratos.map((pago) => {
                return (<Button variant='contained' style={{ margin: 20, backgroundColor: "darkgreen", color: 'white' }}><Link to={`/proyectoInforme/${pago.proyecto.id}`} style={{ textDecoration: 'none', color: 'white' }}>{pago.proyecto.clave}</Link></Button>)
              }) : <></>
          }</div>
        ),
      })
    }

    const datos = {
      columns: columnas, rows: solicitudes

    }
    setData(datos)
  }

  const handleOpenDocumentos = async (solicitud) => {
    setOpenDocumentos(true)
    setSolicitud(solicitud)
    const resDocumentos = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/documentosSolicitud/${solicitud.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    })

    const documentos = await resDocumentos.json()
    setDocumentosGuardados(documentos)
  }

  const handleClickOpen = (sEditar) => {
    setOpenDialog(true);
    setSolicitud(sEditar)
    setComentario({ ...comentario, 'idSolicitud': sEditar.id, estado: sEditar.estado })
    //console.log(`id solicitud ${sEditar.id} comentario ${JSON.stringify(comentario)}`)
    setValue({ id: sEditar.estado, label: sEditar.estado })
  };

  const handleSubmitNotificacion = async (e) => {
    e.preventDefault()
    setLoading(true)
    /*if (!Boolean(comentario.paraJefe) && !Boolean(comentario.paraAsistente) && Number(comentario.destinatarios.length) === 0) {
      setMensaje('Debe seleccionar al menos una casilla de verificación')
      setOpen(true)
      return
    }*/
    if (solicitud.estado === 'autorizada' && asistentes.length > 1 && comentario.destinatarios.length === 0) {
      setSeverity('error')
      setMensaje('Debe seleccionar al menos una persona asistente para atender la solicitud')
      setOpen(true)
      setLoading(false)
      return
    }
    comentario.estado = comentario.estado ? comentario.estado : solicitud.estado
    comentario.idSolicitud = solicitud.id

    //console.log(`JSON.stringify(comentario) ${JSON.stringify(comentario)}`)
    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/${solicitud.id}/${sessionStorage.getItem('idEntidad')}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      },
      body: JSON.stringify(comentario)
    })
    const data = await res.json()
    if (data.message) {
      if (res.status === 200) {
        setSeverity('success')
        const comentarioGuardado = data.comentario
        //console.log(`comentarioGuardado ${JSON.stringify(comentarioGuardado)}`)
        await cargarDatosTabla()
        setLoading(false)
        // solicitud.comentarioSolicituds.unshift(comentarioGuardado)
      }
      else
        setSeverity('error')
      setOpen(true)
      setMensaje(data.message)
      return
    }
  }

  const handleClose = () => {
    setOpenDialog(false);
    setErrorPedido(false)
    asistentes.map((asistente) => (
      asistente.seleccionado = false
    ))
    comentario.destinatarios = []
    setComentario({ ...comentario, comentarios: null, paraJefe: false, paraAsistente: false })
    setOpen(false)
  };

  const handleBuscar = async (e) => {
    e.preventDefault()
    if (claves.length === 0 && clave === '') {
      return
    }
    if (claves.length === 0) {
      setClaves([clave])
    }
    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/buscarClaves`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      },
      body: JSON.stringify({ claves: (claves.length === 0 ? [clave] : claves) })
    })
    const solicitudesEncontradas = await res.json()
    setData({ ...data, rows: solicitudesEncontradas })
    setPageSize(5)
    setClave('')
  };

  /*const mostrarDocumento = async (value, tipo) => {
    //console.log(`value en desplegarDocumentoPDF ${value}`)
    await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/mostrarFactura`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil'),
        "ruta": value,
        "tipo": tipo
      }
    }
    ).then((res) => res.blob())
      .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
        var _url = window.URL.createObjectURL(blob);
        window.open(_url, "_blank").focus(); // window.open + focus
      }).catch((err) => {
        console.log(err);
      });
  }*/

  const desplegarDocumentoPDF = async (value, tipo) => {
    //console.log(`value en desplegarDocumentoPDF ${value}`)
    await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/mostrarDocumentoPDF`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil'),
        "documento": JSON.stringify(value),
        "tipo": tipo
      },

    }
    ).then((res) => res.blob())
      .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
        var _url = window.URL.createObjectURL(blob);
        window.open(_url, "_blank").focus(); // window.open + focus
      }).catch((err) => {
        console.error(err);
      });
  }


  //console.log(`decodificado en forma ${JSON.stringify(decoded)}`)

  const idResponsable = decoded.id;
  //const filterModelRef = useRef({ items: [{ columnField: "estado", operatorValue: "not", id: 13752, value: "cancelada" }] });
  const [comentario, setComentario] = useState({ idSolicitud: null, comentarios: null, idResponsable, estado: null, paraJefe: false, paraAsistente: false, destinatarios: [] })
  //const [filterModel, setFilterModel] = useState(filterModelRef.current);
  const [filterModel, setFilterModel] = useState({ items: [{ columnField: "estado", operatorValue: "not", id: 13752, value: "cancelada" }] });

  useEffect(() => {
    (async () => {
      await cargarDatosTabla()

      const resAsistentes = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/leerAsistentesEntidad/${sessionStorage.getItem('idEntidad')}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": sessionStorage.getItem('token'),
          "perfil": sessionStorage.getItem('perfil')
        }
      })

      const asistentesLeidas = await resAsistentes.json()

      setAsistentes(asistentesLeidas)
      if (actualizaFiltro === 0) {
        setFilterModel({
          items: [{ columnField: 'estado', operatorValue: 'isAnyOf', value: ["registrada", "autorizada", "ajustesJefe", "ajustesAsistente", "firmaAutografa", "enRevision", "registrarGastos", "devolucionCaja"] }],
        })
        setActualizaFiltro(1)
      }

    })();
    // eslint-disable-next-line
  }, [solicitud, ocultarContratos]
  )

  /*useEffect(() => {
    if(filterModel.items && filterModel.items[0] && filterModel.items[0].value  && filterModel.items[0].operatorValue==='dateRange' ){
      setStartDate (dayjs(filterModel.items[0].value[0]))
      setEndDate(dayjs(filterModel.items[0].value[1]));
    }
  }, [filterModel]);*/

  return (
    <div style={{ display: 'flex', marginTop: '50px' }}>
      <Grid container rowSpacing={2} columnSpacing={5}>
        <Grid item xs={12} md={12}>
          <Card>

            <Box sx={{ flexGrow: 1, m: 5 }}>
              <form onSubmit={handleBuscar}>
                <Grid container rowSpacing={2} columnSpacing={5}>
                  <Grid item xs={12} md={8}>
                    <Autocomplete
                      multiple
                      id="claves"
                      options={[]}
                      freeSolo
                      inputValue={clave}
                      value={(claves instanceof Array) ? claves : claves.split(', ')}
                      onChange={(event, newValue) => {
                        setClaves(newValue)
                      }}
                      getOptionLabel={(option) => option.label}
                      renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => (
                          option ? (
                            <Chip
                              variant="outlined"
                              label={option}
                              {...getTagProps({ index })} sx={{
                                height: 'auto',
                                '& .MuiChip-label': {
                                  display: 'block',
                                  whiteSpace: 'normal',
                                },
                              }}
                            />
                          ) : null
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label={"Claves"}
                          focused multiline
                          onChange={(e) => {
                            const valor = e.target.value
                            setClave(valor)
                            //setProductoServicio(valor)
                          }}
                          placeholder="Presione Enter al terminar de capturar cada una"
                          helperText='Indique las claves que desea encontrar'
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Button variant='contained' color='primary' type='submit' style={{ margin: 5, width: '100%' }}
                    >
                      Buscar por claves SIIUAM
                    </Button>
                    <Button variant='contained' color='primary' type='button' style={{ margin: 5, width: '100%' }}
                      onClick={async () => { await cargarDatosTabla() }}>
                      Cancelar búsqueda
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Box>

          </Card>
        </Grid>

        <Grid item xs={12} md={12}>
          <Card style={{ height: '100%', width: '100%' }}>
            <CardHeader title='Solicitudes de servicio'></CardHeader>
            <CardContent sx={{ height: 700 }}>

              {esAsistente ? <FormControlLabel
                label="Ocultar las solicitudes de tipo Contrato sin pagos en trámite"
                control={
                  <Checkbox
                    checked={ocultarContratos}
                    onChange={() => { setOcultarContratos(!ocultarContratos) }}
                  />
                }
              /> : <></>}
              <DataGrid {...data} pageSize={pageSize} getRowHeight={() => 'auto'} getRowId={(row) => row.id} sx={{
                [`& .${gridClasses.cell}`]: {
                  py: 1,
                },
                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
              }}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} rowsPerPageOptions={[5, 10, 15]} localeText={esES.components.MuiDataGrid.defaultProps.localeText} components={{ Toolbar: CustomToolbar }}
                /*filterModel={filterModelRef.current}
                onFilterModelChange={(newFilterModel) => {
                  filterModelRef.current = newFilterModel;
                  setFilterModel(newFilterModel);
                }}*/
                filterModel={filterModel}
                onFilterModelChange={(newFilterModel) => {
                  if (newFilterModel.items && newFilterModel.items.length > 0 && newFilterModel.items[0].operatorValue !== 'dateRange') {
                    //console.log('limpiando fechas')
                    setStartDate(null)
                    setEndDate(null)
                  }

                  setFilterModel(newFilterModel);
                }}
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={(newModel) => {
                  // Forzar la columna 'fecha' a permanecer oculta
                  setColumnVisibilityModel((prevModel) => ({
                    ...newModel,
                    fecha: false,
                  }));
                }}
              >



              </DataGrid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Dialog open={openDialog}>
        <form onSubmit={handleSubmitNotificacion}>
          <DialogTitle>Seguimiento a la solicitud {solicitud ? solicitud.folio : ''}</DialogTitle>
          <DialogContent>
            <DialogContentText>
            </DialogContentText>
            <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>

              <Grid item xs={12}>
                <Autocomplete
                  value={value}
                  onChange={(event, newValue) => {
                    setValue(newValue);
                    if (newValue) {
                      //console.log(newValue.id)
                      comentario.estado = newValue.id
                    }
                    else {
                      comentario.estado = solicitud.estado
                      // console.log(solicitud.estado)
                    }
                    if (newValue.id === 'concluida' && solicitud.tipo === 'adquisiciones') {
                      if (solicitud.adquisicions[0].pedido === null) {
                        setSeverity('error')
                        setMensaje(`No se puede concluir porque no se ha subido evidencia del pedido. Puede poner la solicitud en estado "Ajustes" para que se pueda actualizar esa información. El monto de la solicitud debe coincidir con el monto del pedido.`)
                        setOpen(true)
                        setErrorPedido(true)
                      }
                      else {
                        setSeverity('warning')
                        setMensaje(`Antes de concluir se sugiere verificar que el monto de la evidencia del pedido coincide con el que se especifica en el oficio de la solicitud, de lo contrario poner en estado "Ajustes" para que se pueda actualizar esa información. En las solicitudes concluídas ya no será posible actualizar información.`)
                        setOpen(true)
                        setErrorPedido(false)
                      }
                    }
                    if (newValue.id === 'concluida' && solicitud.tipo === 'contrato') {
                      if (solicitud.contratos[0].pagoContratos.filter(pago => pago.estado === null).length > 0) {
                        setSeverity('warning')
                        setMensaje(`Este contrato tiene pagos sin tramitar, si se concluye se pondrán esos pagos como cancelados y su monto regresará a la partida correspondiente. \nSi existen pagos en proceso el monto continuará como comprometido y una vez que se concluya el trámite pasará a ejercido.`)
                        setOpen(true)
                      }
                    }
                  }}
                  id="estado"
                  name="estado"
                  options={esJefe ? opcionesEstadoJefatura : esAsistente ? solicitud && solicitud.tipo === 'contrato' ? opcionesEstadoContrato : opcionesEstadoAsistente : opcionesEstado}
                  sx={{ width: 300 }}
                  renderInput={(params) => <TextField {...params} label="Estado Solicitud" focused required />}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField label='Comentario' id='comentarios' name='comentarios' focused required multiline onChange={(event) => {
                  setComentario({ ...comentario, [event.target.name]: event.target.value })
                }} sx={{ width: '100%' }} />
              </Grid>

              <Grid item xs={12}>
                <FormGroup>
                  {comentario.estado !== 'autorizada' ?
                    <FormControlLabel control={<Checkbox checked={comentario.paraJefe}
                      onChange={(event) => {
                        setComentario({ ...comentario, 'paraJefe': event.target.checked })
                        setMensaje('')
                        setOpen(false)
                      }}
                      inputProps={{ 'aria-label': 'controlled' }} />} label="Notificar a Titular" />
                    : <></>
                  }
                  {asistentes.length === 1 && comentario.estado !== 'autorizada' ?
                    <FormControlLabel required control={<Checkbox checked={comentario.paraAsistente}
                      onChange={(event) => {
                        setComentario({ ...comentario, 'paraAsistente': event.target.checked })
                        setMensaje('')
                        setOpen(false)
                      }}
                      inputProps={{ 'aria-label': 'controlled' }} />} label="Notificar a Asistente" />
                    :
                    <>
                      {
                        asistentes.length > 1 ?
                          asistentes.map((asistente) => (
                            <FormControlLabel required control={<Checkbox checked={asistente.seleccionado}
                              onChange={(event) => {
                                const seleccionado = event.target.checked
                                asistente.seleccionado = seleccionado
                                if (Boolean(seleccionado)) {
                                  comentario.destinatarios.push(asistente)
                                }
                                else {
                                  comentario.destinatarios = comentario.destinatarios.filter(destinatario => destinatario.id !== asistente.id)
                                }

                                //console.log(`DESTINATARIOS ${JSON.stringify(comentario.destinatarios)}`)
                                setComentario({ ...comentario })
                                setMensaje('')
                                setOpen(false)
                              }}
                              inputProps={{ 'aria-label': 'controlled' }} />} label={`Notificar a ${asistente.nombreCompleto}`} />
                          ))
                          : <></>
                      }
                    </>
                  }

                </FormGroup>
              </Grid>


            </Grid>
          </DialogContent>
          <DialogActions>
            <Box sx={{ width: '100%' }}>
              <Collapse in={open}>
                <Alert severity={severity}
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                  style={{ marginTop: 30 }}
                >
                  {mensaje}
                </Alert>
              </Collapse>
            </Box>
            <Button onClick={handleClose}>Cerrar</Button>
            <Button type='submit' disabled={errorPedido || loading} >Enviar notificación</Button>
          </DialogActions>
        </form>

      </Dialog>
      <Dialog open={openContrato} fullWidth={true} maxWidth='lg'>
        <DialogTitle>Documentos de los pagos {solicitud ? solicitud.folio : ''}</DialogTitle>
        <DialogContent style={{ backgroundColor: '#FFFEED', padding: 20 }}>
          <DialogContentText>
          </DialogContentText>
          <Box sx={{
            width: '60%',
            position: 'fixed',
            zIndex: 10000
          }}>
            <Collapse in={openPago}>
              <Alert severity={severityPago}
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setOpenPago(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
                style={{ marginTop: 30 }}
              >
                {mensajePago}
              </Alert>
            </Collapse>
          </Box>
          {contrato ? contrato.pagoContratos.map((pago) => {
            return (

              <Accordion expanded={expanded[pago.id]} id={pago.id} onChange={handleChange(pago.id)}>
                <AccordionSummary
                  expandIcon={<Button style={{ textTransform: 'none' }} disabled={pago.estado === null}>
                    {expanded[pago.id] ? '' : 'Más información'}{expanded[pago.id]}
                    <ExpandMoreIcon />
                  </Button>} id={pago.id}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={3}><strong>Estado: </strong> {pago.estado === null ? 'Sin tramitar' : pago.estado}</Grid>
                    <Grid item xs={12} sm={3}><strong>Monto: </strong> {pago.monto.toLocaleString("es-MX", { style: "currency", currency: "MXN" })}</Grid>
                    <Grid item xs={12} sm={3}>
                      {esAsistente && pago.estado && pago.estado !== 'tramiteConcluido' && pago.estado !== 'cancelado' ?
                        <Box onClick={(e) => e.stopPropagation()}>
                          <Autocomplete
                            value={pago.estado}
                            disabled={loading}
                            onChange={async (event, newValue) => {

                              setLoading(true)
                              pago.estado = newValue.id
                              const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/contrato/pago/${pago.id}`, {
                                method: "PUT",
                                headers: {
                                  "Content-Type": "application/json",
                                  "x-access-token": sessionStorage.getItem('token'),
                                  "perfil": sessionStorage.getItem('perfil')
                                },
                                body: JSON.stringify({
                                  pago
                                })
                              })

                              const data = await res.json()

                              if (res.status === 200) {
                                setSeverityPago('success')
                                const comentario = { idSolicitud: solicitud.id, estado: solicitud.estado, comentarios: `Estado de pago ${pago.estado} ${pago.descripcion ? '\nDescripción: ' + pago.descripcion : ''}`, idResponsable }
                                await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/${solicitud.id}/${sessionStorage.getItem('idEntidad')}`, {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json",
                                    "x-access-token": sessionStorage.getItem('token'),
                                    "perfil": sessionStorage.getItem('perfil')
                                  },
                                  body: JSON.stringify(comentario)
                                })
                              }
                              else
                                setSeverityPago('error')

                              if (data.message) {
                                setOpenPago(true)
                                setMensajePago(data.message)
                                setLoading(false)
                                return
                              }
                              setLoading(false)
                            }}
                            id="estado"
                            name="estado"
                            options={opcionesEstadoPago}
                            fullWidth
                            renderInput={(params) => <TextField {...params} label="Estado del trámite" focused required multiline />}
                          /></Box> : <></>}
                    </Grid>
                    <Grid item xs={12} sm={3}><strong>Última actualización: </strong>{(new Date(pago.updatedAt)).toLocaleDateString('es-MX', { day: "2-digit", month: "short", year: "numeric" })}</Grid>
                    <Grid item xs={12}>

                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container justifyContent='stretch' spacing={5} key={pago.id} style={{ marginTop: 5 }}>
                    {pago.descripcion ? <> <Grid item xs={2}>Descripción:</Grid>
                      <Grid item xs={10}>{pago.descripcion}</Grid></> : <></>}
                    {pago.observaciones ? <> <Grid item xs={2}>Observaciones:</Grid>
                      <Grid item xs={10}>{pago.observaciones}</Grid></> : <></>}
                    {pago.rutaPDF ?
                      <>
                        <Grid item xs={2}>Factura:</Grid>
                        <Grid item xs={5}><Button color='success' size='small' onClick={async () => { await desplegarDocumentoPDF(pago) }} sx={{ wordBreak: 'break-all', textTransform: 'none' }}>{colocarNombre(pago.rutaPDF)}</Button></Grid>
                        {pago.rutaXML ?
                          <Grid item xs={5}><Button color='success' size='small' sx={{ wordBreak: 'break-all', textTransform: 'none' }} href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(pago.rutaXML)}`} download={colocarNombre(pago.rutaXML)}>{colocarNombre(pago.rutaXML)}</Button></Grid>
                          : <></>}
                      </> : <></>}
                    {pago.documentosAnexos ?
                      <Grid item xs={12}><Button color='success' size='small' href={`${pago.documentosAnexos}`} target='_blank'>Documentos anexos en Drive</Button></Grid>
                      : <></>}

                    {pago.documentoPagos && pago.documentoPagos.length > 0 ? <Grid item xs={12} md={12} spacing={2}>


                      <Box
                        id="category-c"
                        sx={{ fontSize: '12px', textTransform: 'none', fontWeight: 700, mb: 2 }}
                      >
                        <TableContainer sx={{ mb: 5, display: !pago.documentoPagos || pago.documentoPagos.length === 0 ? 'none' : 'block', width: '90%' }}>
                          <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                              <TableRow key='encabezado'>
                                <TableCell key='ninguna' align="center" colSpan={3}>
                                  Documentos adjuntos registrados
                                </TableCell>
                              </TableRow>
                              <TableRow key='encabezado2'>
                                {columns.map((column) => (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ top: 57, minWidth: column.minWidth }}
                                  >
                                    {column.label}
                                  </TableCell>

                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {
                                pago.documentoPagos && pago.documentoPagos.length > 0 ? pago.documentoPagos
                                  .map((row, index) => {
                                    return (
                                      <TableRow hover role="checkbox" tabIndex={-1} key={row.indice}>
                                        {
                                          columns.map((column) => {
                                            const value = row[column.id];

                                            // total=Number(total)+Number(value)
                                            // console.log(`column.id ${column.id} row[column.id] ${row[column.id]}`)                    
                                            return (
                                              <TableCell key={column.id} align={column.align} style={{ wordBreak: 'break-word' }}>
                                                {column.id === 'ruta' ? <Button size='small' variant="text" style={{ marginTop: 20, color: 'darkgreen', width: '100%', textTransform: "none" }} onClick={async () => { await desplegarDocumentoPDF(row) }}><span style={{ wordBreak: 'normal', whiteSpace: 'nowrap' }}>{colocarNombreDocumento(value)}</span></Button> : value}
                                              </TableCell>
                                            );
                                          })}

                                      </TableRow>
                                    );
                                  }) : <TableRow hover role="checkbox" tabIndex={-1} >

                                  <TableCell align='center' colSpan={3}>
                                    No hay documentos registrados
                                  </TableCell>

                                </TableRow>}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>

                    </Grid> : <></>}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )
          }) : <></>}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenContrato(false) }}>Cerrar</Button>
        </DialogActions>


        <Box sx={{ width: '100%' }}>
          <Collapse in={open}>
            <Alert severity={severity}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              style={{ marginTop: 30 }}
            >
              {mensaje}
            </Alert>
          </Collapse>
        </Box>

      </Dialog>

      <Dialog open={openDocumentos} fullWidth={true}
        maxWidth='xl' >

        <DialogTitle>Añadir documentos a la solicitud {solicitud ? solicitud.folio : ''}</DialogTitle>
        <DialogContent style={{ backgroundColor: '#FFFEED' }}>
          <DocumentosAdjuntosSolicitudGuardados documentosGuardados={documentosGuardados} setDocumentosGuardados={setDocumentosGuardados}></DocumentosAdjuntosSolicitudGuardados>
          <DocumentosAdjuntosFormulario idSolicitud={solicitud ? solicitud.id : null} idAutor={idResponsable} documentosGuardados={documentosGuardados} setDocumentosGuardados={setDocumentosGuardados}></DocumentosAdjuntosFormulario>
          {/*<DocumentosAdjuntosSolicitud documentos={documentos} setDocumentos={setDocumentos} ventana={true}></DocumentosAdjuntosSolicitud>*/}
        </DialogContent>
        <DialogActions>
          <Button variant='contained' style={{ backgroundColor: "darkgreen", color: 'white' }} onClick={() => { setOpenDocumentos(false) }}>Cerrar Ventana</Button>
        </DialogActions>

      </Dialog>

    </div>
  );
}